<template>
    <router-link :to="{ name: 'Contact', params: { id: local_contactfile.contact.id}}">
        <div
            v-if="local_contactfile"
            class="contactfilePreviewCard"
            :class="{'inset': inset}"
        >
            <v-layout
                row
                wrap
            >
                <div
                    v-if="!inset"
                    style="background:rgba(0,0,0,0.05);border-radius:25px;padding:4px;margin: 10px;aspect-ratio: 1/1;width:32.5px;height:32.5px;"
                >
                    <v-icon>
                        {{ 'mdi-file' }}
                    </v-icon>
                </div>
                <div>
                    <b>{{ local_contactfile.name }}</b><br/>
                    {{ convertToLocal(local_contactfile.created_at) }}
                    <br/>
                    <span>{{ local_contactfile.contact.full_name }}</span>
                </div>
            </v-layout>
        </div>
    </router-link>

</template>

<script>
import api from '@/api'

export default {
    name: 'ContactFilePreview',
    props: ['contactFile', 'id', 'inset'],
    data() {
        return {
            local_contactfile: null,
            searching: false
        }
    },
    created () {
        if (this.contactFile){
            this.local_contactfile = JSON.parse(JSON.stringify(this.contactFile))
        } else {
            if(this.id){
                this.fetch()
            }
        }
    },
    methods: {
        fetch () {
            this.searching = true
            api.userform.contactFilesPage.get(this.id)
                .then(data => {
                    this.searching = false
                    this.local_contactfile = data
                })
        }
    }
}
</script>

<style scoped>
.contactfilePreviewCard {
    background:rgba(0,0,0,0.05);
    padding:5px;
    border-radius:5px;
    cursor:pointer;
}

.contactfilePreviewCard:hover {
    background:rgba(0,0,0,0.1);
}

.inset {
    background: unset;
    padding: unset !important;
}

a {
    text-decoration: none;
    color: black;
}
</style>